<template>
  <div class="top-bar">
    <research-report-chart-list-item @noDownloadPermissions="noDownloadPermissions" :showDel="false" @uncollect="uncollect" @collection="collection" @download="download" @change="change" v-for="(item, index) in data" :key="index" :data="item"></research-report-chart-list-item>
  </div>
</template>

<script>
import ResearchReportChartListItem from '@/components/research-report/ResearchReportChartListItem';

export default {
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    change() {
      this.$emit('change');
    },
    uncollect(res) {
      this.$emit('uncollect', res);
    },
    collection(res) {
      this.$emit('collection', res);
    },
    changeChecked(res) {
      this.$emit('change', res);
    },
    download(res) {
      this.$emit('download', res);
    },
    noDownloadPermissions() {
      this.$emit('noDownloadPermissions');
    }
  },
  components: {
    ResearchReportChartListItem
  }
};
</script>

<style lang="scss" scoped>

</style>
